import { useEffect, useState } from "react";
import InputFilterBox from "../InputFilterBox/web";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { DownArrow } from "shared-components/Components/CustomIcons/DownArrow/web";
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";
import { normalizeTextToLowerCase } from "@Utils/Functions";
import { seasonsFilters } from "../options";
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import { getLabelSeasonsAndDates } from "src/utils/Functions";

export const SeasonAndDatesFilter = ({show}) => {
    if (!show) return null;

	const { filters, filtersTags } = useFilters();
	const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();
    const [calendarIsOpen, setCalendarIsOpen] = useState<boolean>();
    const [showSeasons, setShowSeasons] = useState<boolean>(filters?.season ? true : false);
    const [rangeDate, setRangeDate] = useState<any>([filters?.dateFrom && filters?.dateFrom, filters?.dateTo && filters?.dateTo]);
    const filterLabel = getLabelSeasonsAndDates(filtersTags);

    useEffect(() => {
        if (rangeDate && rangeDate[0]) {
            const startRange = rangeDate[0]
            const endRange = rangeDate[1]                  
        
            if (startRange || endRange) {        
                changeFilters({ dateFrom: startRange && startRange !== '' ? { text: startRange, value: startRange } : null, dateTo: endRange && endRange !== '' ? { text: endRange, value: endRange } : null, season: null })
            }
            else if (!startRange && !endRange) {        
                changeFilters({ dateFrom: null, dateTo: null, season: null })
            }
        }
    }, [rangeDate])

    useEffect(() => {
        if (!filters?.dateFrom && filters?.dateTo) {
          setRangeDate(['', filters?.dateTo])
        }
        if (!filters?.dateTo && filters?.dateFrom) {
          setRangeDate([filters?.dateFrom, ''])
        }
        if (!filters?.dateTo && !filters?.dateFrom) setRangeDate(null)
    }, [filters?.dateFrom, filters?.dateTo])

    const isActive = () => {
        if (
            filters?.dateFrom ||
            filters?.dateTo ||
            filters?.season
        ) return true;
        else return false;
    }

    const handleCleanFilter = () => {
        const valuesToReset = {
            dateFrom: null,
            dateTo: null,
            season: null,
        }

        changeFilters(valuesToReset)
    }
    
    return (
        <InputFilterBox
            label={filterLabel}
            customWidth={360}
            customHeight={calendarIsOpen ? 515 : "unset"}
            active={isActive()}
            onCancelFilter={handleCleanFilter}
        >
            <div className="dateFilter">
                <div className="dateFilter__selectors">
                    <button
                        className="dateFilter__selector"
                        disabled={!showSeasons}
                        onClick={() => {
                            setShowSeasons(false);
                        }}>
                        Buscar por Calendario
                    </button>
                    <button
                        className="dateFilter__selector"
                        disabled={showSeasons}
                        onClick={() => {
                            setShowSeasons(true);
                        }}>
                        Buscar por Temporada
                    </button>
                </div>
                {showSeasons ? (
                    <div className="otherFilters__container" id="publicationDate">
                        <div className="otherFilters__container__option more-filters">
                            <input
                                type="radio"
                                className="radioCustomInput"
                                name="season"
                                id="indiferente"
                                onChange={() =>
                                    changeFilters({
                                        season: null,
                                        dateFrom: null,
                                        dateTo: null,
                                    })
                                }
                                value="-1"
                                defaultChecked
                            />
                            <label htmlFor="indiferente">Indiferente</label>
                        </div>
                        {seasonsFilters.map((val, i) => {
                            const idValue = normalizeTextToLowerCase(val.text);
                            return (
                                <div
                                    key={"season-filter - " + i}
                                    className="otherFilters__container__option more-filters">
                                    <input
                                        type="radio"
                                        className="radioCustomInput"
                                        name="season"
                                        id={idValue}
                                        onChange={() =>
                                            changeFilters({
                                                season: {
                                                    text: val.text,
                                                    value: val.value,
                                                },
                                                dateFrom: null,
                                                dateTo: null,
                                            })
                                        }
                                        value={val.value}
                                        defaultChecked={
                                            filters?.season &&
                                            filters?.season == val.value
                                        }
                                    />
                                    <label htmlFor={idValue}>{val.text}</label>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <>
                        <div className="dateFilter__labels">
                            <span>Llegada</span>
                            <div></div>
                            <span>Salida</span>
                        </div>
                        <div className="dateFilter__calendar">
                            <DateRangePicker
                                format="dd/MM/yyyy"
                                onChange={e => {
                                    if (e) {
                                        const values = e
                                            .toLocaleString("en", {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit",
                                            })
                                            .split(",");

                                        const dates = values.map(v => {
                                            if (v.split("/").length > 1) {
                                                const [month, day, year] = v.split("/");
                                                return `${year}/${month}/${day}`;
                                            } else "";
                                        });
                                        setRangeDate(dates);
                                    } else {
                                        setRangeDate(null);
                                    }
                                }}
                                value={rangeDate}
                                calendarClassName=".filterCalendar"
                                className=".filterCalendarPicker"
                                minDate={new Date()}
                                calendarIcon={null}
                                clearIcon={null}
                                onCalendarOpen={() => setCalendarIsOpen(true)}
                                onCalendarClose={() => setCalendarIsOpen(false)}
                            />
                        </div>
                    </>
                )}
            </div>
        </InputFilterBox>
    )
}